import React, { useContext, useEffect } from 'react'
import Space from '../atoms/Space'
import { View } from '../other/html'
import ListLeftColumn from './item/ListLeftColumn'
import { ItemContext, ItemDispatchContext } from 'src/contexts/itemContext'
import ArchivedPriceColumn from './item/ArchivedPriceColumn'
import ExpandedAccepted from './item/ExpandedAccepted'

const ArchivedItem = (): JSX.Element => {
  const itemContext = useContext(ItemContext)
  const dispatchItemContext = useContext(ItemDispatchContext)

  if (itemContext === null || dispatchItemContext === null) {
    throw new Error('itemContext must be used within a ItemProvider')
  }
  useEffect(() => {
    dispatchItemContext({ type: 'SET_BAR', payload: 'pick_up' })
  }, [dispatchItemContext])

  const { index, expandedView } = itemContext
  const backgroundColor = (i: number): string => (i % 2 === 0 ? 'bg-lightGrey' : 'bg-white')
  const radiusStyles = expandedView ? 'rounded-b-4 rounded-t-2' : 'rounded-2'
  const cursorStyles = expandedView ? 'cursor-default' : 'cursor-pointer'
  return (
    <View
      className={`shadow-bothSmall  mb-4 ${backgroundColor(index)} ${radiusStyles} ${cursorStyles}`}
      onClick={() => {
        dispatchItemContext({ type: 'EXPAND_VIEW' })
      }}>
      <Space y={2} />
      <View className="flex justify-between">
        <ListLeftColumn showLikeIcon={false} showDealersIcon={false} />
        <ArchivedPriceColumn viewType="archived" />
      </View>
      <Space y={2} />
      <ExpandedAccepted variant="archived" expandedView={expandedView} />
    </View>
  )
}

export default React.memo(ArchivedItem)
